import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useEquipmentMasterHook from './equipment-master.hook';
import * as styled from './equipment-master.styles';
import themes from './themes';
import EditableTable from '../../components/edit-table';

export interface EquipmentMasterProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = EquipmentMasterProps & ThemeOverride;

function EquipmentMaster(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t,
    dataForColumns,
    columnNames,
   handleSaveAndDeleteFromTable
  } = useEquipmentMasterHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.EquipmentMaster>
      <EditableTable
          tableData={dataForColumns}
          tableColumns={columnNames}
          Table_Header='EQUIPMENT EDITOR'
          hiddenColumns={[ 'displayseq','remarks','isactive']}
          stillHiddenColumns = {['displayseq']}
          handleSave={handleSaveAndDeleteFromTable}
          showActions_ext = {true}
          allowSelection = {false}
          saveReturnType={'row'}

        //  selectInputReturnType={'value'}
          onlyAddableFields={['equipmentcode', 'equipmentname']}
        />


      </styled.EquipmentMaster>
    </ThemeProvider>
  );
}

export default memo(EquipmentMaster) as unknown as typeof EquipmentMaster;
